import React, { useContext } from "react";
import PropTypes from "prop-types";
import UserPrefsContext from "../../../context/UserPrefs/UserPrefsContext";

import Range from "../../shared/InputElements/Range";

const descriptionFn = val => {
  return val + " seats";
};

const SlideMinSeats = ({
  id = "min-seats-range",
  label = "Minimum Seats",
  description = descriptionFn,
  ...rest
}) => {
  const userPrefs = useContext(UserPrefsContext);

  return (
    <Range
      id={id}
      value={userPrefs.get("minSeats")}
      label={label}
      rangeMin={2}
      rangeMax={7}
      rangeStep={1}
      description={description}
      ariaControls="electric-vehicles-catalog"
      handler={e => userPrefs.set({ minSeats: e.target.value })}
      {...rest}
    />
  );
};

export default SlideMinSeats;

SlideMinSeats.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  description: PropTypes.func
};
